// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#qr-spinner-container {
  width: 100%;
  text-align: center;
}
#qr-spinner-container ion-spinner {
  color: var(--ion-color-primary-contrast, white);
}

ion-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: var(--ion-color-primary-contrast, white);
}

ion-item {
  --background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/qr-component/qr-component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;AACF;AACE;EACE,+CAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oDAAA;AAAF;;AAGA;EACE,yBAAA;AAAF","sourcesContent":["#qr-spinner-container {\n  width: 100%;\n  text-align: center;\n\n  ion-spinner {\n    color: var(--ion-color-primary-contrast, white);\n  }\n}\n\nion-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: var(--ion-color-primary-contrast, white);\n}\n\nion-item{\n  --background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
